module.exports = __webpack_public_path__ + "static/media/ic-our-experts.bb76e59f.png";